import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { from, Observable, of } from 'rxjs';
import { map, catchError, mergeMap, switchMap } from 'rxjs/operators';


import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';
import { LoadCashs, LoadCash,LoadCashFailure,LoadCashSuccess,LoadCashsFailure,LoadCashsSuccess,CreateCash,CreateCashFailure,CreateCashSuccess,UpdateCash,UpdateCashFailure, UpdateCashSuccess , DeleteCash, DeleteCashFailure,DeleteCashSuccess} from '../actions/cash.actions';
import { CashService } from '../../services/cash.service';
import { SummaryCashModel } from '../../models/summary-cash.model';
import { CashActionTypes } from '../actions/cash.actions';

@Injectable()
export class CashEffects {
  constructor(
    private actions$: Actions,
    private service: CashService
  ) { }

  /** 🔹 Get All */

  
  loadBankAccount$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(CashActionTypes.LoadCashs),
    mergeMap((action: LoadCashs) =>
      this.service.getBySearch(action.payload.filter).pipe(
        map((res: PaginableResponseModel<SummaryCashModel>) => {
          if (!res || !res.isSuccess) {
              return new LoadCashsFailure({ error: 'No se pudo cargar la lista' });
            }
            return new LoadCashsSuccess({
              items: res.values,
              total: res.total
            });
          }),
          catchError(error => of(new LoadCashsFailure({ error })))
        )
      )
    ));


      /** 🔹 Get By Id */
      
      loadCashById$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(CashActionTypes.LoadCash),
        mergeMap((action: LoadCash) =>
          this.service.getById(action.payload.uid).pipe(
            map(response => new LoadCashSuccess(response)),
            catchError(error => of(new LoadCashFailure({ error })))
          )
        )
      ));

       /** 🔹 Update */
        
        updateCash$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CashActionTypes.UpdateCash),
          mergeMap((action: UpdateCash) =>
            this.service.update(action.payload.cash).pipe(
              switchMap(updated => [
                new UpdateCashSuccess({ cash: updated }),
              ]),
              catchError(error => of(new UpdateCashFailure({ error })))
            )
          )
        ));

        /** 🔹 Delete */
        
        deleteCash$: Observable<Action> = createEffect(() => this.actions$.pipe(
          ofType(CashActionTypes.DeleteCash),
          mergeMap((action: DeleteCash) =>
            this.service.delete(action.payload.uid).pipe(
              switchMap(() => [
                new DeleteCashSuccess({ uid: action.payload.uid }),
              ]),
              catchError(error => of(new DeleteCashFailure({ error })))
            )
          )
        ));



}
